import { render, staticRenderFns } from "./BsListTileAction.vue?vue&type=template&id=5a8e1035&scoped=true&"
import script from "./BsListTileAction.vue?vue&type=script&lang=js&"
export * from "./BsListTileAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8e1035",
  null
  
)

export default component.exports